<div class="p-8 text-base">
  <h1>Regulamin Platformy Soft4Lean SWI</h1>
  <p>
    Niniejszy Regulamin określa ogólne warunki korzystania z Usług dostarczanych za pośrednictwem Platformy
    <strong>Soft4Lean SWI</strong>.
  </p>

  <h4>Definicje:</h4>
  <ol class="list-decimal">
    <li><strong>Klient</strong> - podmiot korzystający z Platformy w ramach Konta Klienta.</li>
    <li>
      <strong>Konto Klienta</strong> - dostęp do Platformy dla Klienta po dokonaniu Rejestracji lub przeprowadzeniu
      Negocjacji, za pośrednictwem którego Klient może korzystać z Usług.
    </li>
    <li>
      <strong>Negocjacje</strong> - proces negocjacji zakończony ustaleniem warunków współpracy między Operatorem
      Platformy a podmiotem, który zamierza zostać Klientem z wykorzystaniem planu abonamentowego, który nie został
      opisany w niniejszym Regulaminie.
    </li>
    <li>
      <strong>Okres Rozliczeniowy</strong> - okres rozliczeniowy za świadczenie Usługi. Wynosi miesiąc kalendarzowy.
    </li>
    <li>
      <strong>Operator Platformy</strong> - Spółka Intechnity prowadząca działalność gospodarczą na podstawie wpisu do
      Centralnej Ewidencji i Informacji o Działalności Gospodarczej pod firmą Intechnity Sp. z o.o., ul. Technologiczna
      2, 45-839 Opole, NIP: 7543368340, REGON 0001101111.
    </li>
    <li>
      <strong>Polityka Prywatności</strong> - polityka prywatności i plików cookies zawierająca postanowienia dotyczące
      przetwarzania danych osobowych przez Operatora Platformy.
    </li>
    <li>
      <strong>Regulamin</strong> - niniejszy regulamin Platformy Soft4Lean SWI. Dokument ten stanowi jednocześnie
      regulamin świadczenia usług drogą elektroniczną, o którym mowa w art. 8 ust. 1 pkt 1 ustawy o świadczeniu usług
      drogą elektroniczną.
    </li>
    <li>
      <strong>Rejestracja</strong> - proces utworzenia Konta Klienta, na który składa się podanie danych wymaganych
      przez Platformę, akceptacja Regulaminu i Polityki Prywatności, oraz aktywacja Konta Klienta.
    </li>
    <li><strong>Plan</strong> -rodzaj dostępu do funkcjonalności w ramach Konta Klienta.</li>
    <li>
      <strong>Platforma</strong> - prowadzona przez Operatora Platformy internetowa platforma technologiczna dostępna w
      domenie: <a href="https://soft4lean.app">https://soft4lean.app</a>.
    </li>
    <li><strong>Pośrednik płatności</strong> - platforma Stripe.</li>
    <li>
      <strong>Umowa</strong> - zawarta na odległość umowa o świadczenie Usług w ramach Platformy zawierana między
      Operatorem Platformy a Klientem za pośrednictwem Platformy w momencie akceptacji przez Klienta Regulaminu i
      rejestracji Konta Klienta. Umowa jest zawierana na czas nieokreślony.
    </li>
    <li>
      <p>
        <strong>Usługi</strong> - usługi świadczone lub udostępniane przez Operatora Platformy z wykorzystaniem
        Platformy. Szczegółowy wykaz Usług i funkcjonalności Platformy dostępny jest pod adresem
        <a href="https://soft4lean.app/landing">https://soft4lean.app/landing</a>.
      </p>
    </li>
  </ol>

  <h4>1. Postanowienia wstępne</h4>
  <ol class="list-decimal">
    <li>
      Niniejszy Regulamin określa zasady korzystania z Platformy przez Klienta. Każdy Klient obowiązany jest zapoznać
      się z treścią Regulaminu i zaakceptować jego postanowienia przed rozpoczęciem korzystania z Platformy.
    </li>
    <li>
      W ramach Platformy Operator Platformy umożliwia korzystanie z funkcjonalności Platformy. Główną funkcjonalnością
      Platformy jest obsługa interaktywnych kiosków stacjonarnych w środowisku chmurowym. Platforma zapewnia
      infrastrukturę, w tym serwery, przestrzeń dyskową i zasoby obliczeniowe, a także środowisko wykonawcze.
    </li>
    <li>
      Korzystając z Platformy, Klient wyraża zgodę na związanie się warunkami niniejszego Regulaminu. Jeśli Klient nie
      zgadza się z postanowieniami niniejszego Regulaminu, korzystanie z funkcjonalności Platformy jest niedozwolone.
    </li>
    <li>
      Korzystanie z Konta jest bezpłatne. Korzystanie z Usług w ramach poszczególnych Planów oferujących dostęp do
      funkcjonalności Platformy jest płatne. Płatność uzależniona jest od wyboru Planu Konta i aktualnej oferty
      Platformy. Operator dopuszcza jednak korzystanie z Usług za pośrednictwem Platformy nieodpłatnie - jest to
      wyłączne uprawnienie Operatora.
    </li>
    <li>
      O ile nie zastrzeżono inaczej, ilekroć mowa jest o adresie e-mail Operatora Platformy, jest to adres e-mail:
      contact&commat;intechnity.com.
    </li>
  </ol>

  <h4>2. Konto Klienta</h4>
  <ol class="list-decimal">
    <li>
      Klient może korzystać z funkcjonalności Platformy i Usług wyłącznie po dokonaniu Rejestracji na zasadach
      określonych w niniejszym Regulaminie lub po przeprowadzeniu Negocjacji. Zasady i warunki korzystania z
      funkcjonalności Platformy, w tym zasady dot. płatności zależą od wybranego Planu lub Negocjacji w przypadku
      zamiaru przygotowania przez Operatora szczególnych warunków świadczenia Usług dla danego Klienta.
    </li>
    <li>
      Istnieją następujące rodzaje Planów:
      <ol class="list-disc ml-2">
        <li><strong>Simple</strong> - rozliczany w modelu płatności za każdy kiosk.</li>
      </ol>
    </li>
    <li>
      Szczegóły dotyczące każdego z Planów, w szczególności dostępnych funkcjonalności oraz zakresu Usług dostępne są
      pod adresem <a href="https://soft4lean.app/landing">https://soft4lean.app/landing</a>.
    </li>
    <li>
      Rejestracja Konta Klienta wymaga:
      <ol class="list-disc ml-2">
        <li>
          Wypełnienia formularza dostępnego na Platformie i podania wymaganych danych oraz hasła ustanowionego zgodnie z
          zasadami podanymi w formularzu;
        </li>
        <li>Zapoznania się z Polityką Prywatności i Regulaminem oraz akceptacji ich postanowień;</li>
      </ol>
    </li>
    <li>
      Po spełnieniu obowiązków, o których mowa w pkt 2.4, na podany przez Klienta adres e-mail zostanie wysłane
      potwierdzenie utworzenia Konta Klienta oraz link do jego aktywacji. Rejestracja zostaje zakończona w momencie
      aktywacji Konta przez Klienta. W tym momencie dochodzi do zawarcia umowy o świadczenie usługi prowadzenia Konta.
    </li>
    <li>
      Po aktywacji Konta Klient ma możliwość wyboru Planu. Z wyborem Planu wiąże się obowiązek uiszczenia opłaty z góry
      za Okres Rozliczeniowy za dany Plan, na zasadach określonych w Regulaminie, chyba że Operator dopuszcza możliwość
      nieodpłatnego korzystania z Usług i funkcjonalności Platformy.
    </li>
    <li>
      Klient może w ramach jednego Konta posiadać tylko jeden Plan. W trakcie obowiązywania Planu możliwa jest zmiana na
      inny Plan. W wypadku, gdy Klient zdecyduje się na zmianę Planu na droższy w trakcie trwania Okresu
      Rozliczeniowego, nowy Plan jest aktywny z chwilą opłacenia różnicy w cenie pomiędzy Planem tańszym a Planem
      droższym. W przypadku, gdy Klient zdecyduje się na zmianę Planu na tańszy w trakcie Okresu Rozliczeniowego, zmiana
      Planu zacznie obowiązywać od nowego Okresu Rozliczeniowego.
    </li>
    <li>
      Osoba, która prowadzi działalność gospodarczą lub reprezentuje spółkę prowadzącą działalność gospodarczą i chce
      skorzystać z Usług świadczonych w ramach Platformy w innym zakresie niż ten wskazany w Planach powinna
      skontaktować się z Operatorem Platformy drogą mailową na adres: contact&commat;intechnity.com, przeprowadzić
      Negocjacje, w wyniku których ustalone zostaną indywidualne warunki świadczenia usług za pośrednictwem Platformy.
    </li>
    <li>
      Po zakończeniu Negocjacji, Operator Platformy składa Klientowi ofertę zawarcia umowy o świadczenie usług za
      pośrednictwem Platformy na podstawie informacji przekazanych podczas Negocjacji. Oferta jest ważna przez 1 tydzień
      kalendarzowy, a do jej akceptacji wystarczy twierdząca odpowiedź co najmniej drogą poczty elektronicznej przez
      Klienta. W chwili przyjęcia oferty dochodzi do zawarcia umowy.
    </li>
    <li>
      Klient może posiadać tylko jedno Konto Klienta na Platformie. Zasada ta nie ma zastosowania, jeżeli zaistnieje
      konieczność założenia kolejnego Konta Klienta z powodu braku możliwości dostępu do Konta Klienta lub innych
      ważnych przyczyn wskazanych przez Klienta, przy czym wszelkie wyłączenia w tym zakresie będą szczegółowo
      weryfikowane przez Operatora Platformy, który będzie uprawniony do zawieszenia Konta Klienta na czas weryfikacji
      lub usunięcia Kont Klienta w przypadku braku potwierdzenia okoliczności uzasadniających zastosowanie powyższego
      wyłączenia.
    </li>
    <li>
      Klient zobowiązany jest do podania prawdziwych, poprawnych i aktualnych danych podczas procesu Rejestracji oraz
      korzystania z Platformy. Klient zobowiązany jest do aktualizacji danych w przypadku ich zmiany.
    </li>
    <li>
      Klient zobowiązuje się do zachowania w tajemnicy danych dostępowych do Konta Klienta oraz do ich ochrony przed
      dostępem nieuprawnionych osób trzecich. Klient zobowiązany jest niezwłocznie poinformować Operatora Platformy w
      przypadku powzięcia informacji o uzyskaniu przez nieuprawnione osoby trzecie danych dostępowych do Konta Klienta i
      w miarę możliwości niezwłocznie je zmienić.
    </li>
    <li>
      W celu zapewnienia prawidłowego funkcjonowania usług Platformy oraz ochrony i zapewnienia bezpieczeństwa osób i
      podmiotów z niego korzystających, Operator Platformy zastrzega sobie prawo do przeprowadzenia dodatkowej
      weryfikacji aktualności i prawdziwości danych podanych przez Klienta oraz do żądania od Klienta potwierdzenia
      tożsamości reprezentującej go osoby lub innych niezbędnych danych w sposób wybrany przez Operatora Platformy. W
      przypadku bezskutecznej weryfikacji danych lub tożsamości Klienta, Operator Platformy może zawiesić lub zablokować
      działanie Konta Klienta.
    </li>
  </ol>

  <h4>3. Usługi</h4>
  <ol class="list-decimal">
    <li>W ramach Konta Klienta Klient otrzymuje możliwość korzystania Usług i funkcjonalności Platformy.</li>
    <li>
      Klient jest świadomy, że w celu prawidłowego działania funkcjonalności Platformy, oraz realizacji Usługi może być
      wymagane podjęcie odpowiednich działań przez Klienta.
    </li>
  </ol>

  <h4>4. Cena i Płatności</h4>
  <ol class="list-decimal">
    <li>
      Wysokość ceny za dostęp do Planu zależy od ceny podanej na Platformie w momencie Rejestracji lub ustalonej w
      drodze Negocjacji.
    </li>
    <li>
      W trakcie trwania Umowy Konta możliwa jest zmiana ceny Planu. Zmiana będzie wiążąca wraz z rozpoczęciem następnego
      Okresu Rozliczeniowego pod warunkiem poinformowania Klienta o zmianie ceny na minimum 7 dni przed rozpoczęciem
      następnego Okresu Rozliczeniowego za pośrednictwem wiadomości e-mail wysłanej na adres przypisany do Konta.
    </li>
    <li>
      Płatności za dostęp do funkcjonalności Platformy dokonywane są z góry za dany Okres Rozliczeniowy za pośrednictwem
      Pośrednika Płatności, zgodnie z warunkami ustalonymi przez Pośrednika Płatności.
    </li>
    <li>
      Pobranie opłaty za pierwszy Okres Rozliczeniowy nastąpi z momentem wyboru Planu Konta za Pośrednictwem Pośrednika
      płatności, o którym mowa w punkcie 4.3. W trakcie trwania Umowy Konta pobranie opłaty z góry za kolejny Okres
      Rozliczeniowy następuje automatycznie na 7 dni przed rozpoczęciem następnego Okresu Rozliczeniowego.
    </li>
    <li>
      Płatności za dostęp do funkcjonalności Platformy w przypadku planu, który nie znajduje się w ofercie na stronie
      internetowej, który został przyznany na podstawie Negocjacji następują w formie przelewu bankowego na podstawie
      faktury wystawionej Klientowi przez Operatora Platformy.
    </li>
    <li>
      Płatność uważana jest za dokonaną z chwilą jej zaksięgowania na rachunku bankowym Operatora Platformy, wskazanym
      na fakturze.
    </li>
    <li>
      Faktura VAT wysyłana jest na wskazany przez Klienta adres e-mail lub przypisany do Konta Klienta adres e-mail w
      wersji elektronicznej, na co Klient się zgadza.
    </li>
    <li>Akceptowaną walutą płatności jest polski złoty (PLN) oraz euro (EUR).</li>
    <li>Wszystkie opłaty zawierają podatek VAT, gdzie ma to zastosowanie.</li>
    <li>
      Operator Platformy nie ponosi odpowiedzialności za nieprawidłowe dane podane przez Klienta, na podstawie których
      dokonano płatności.
    </li>
  </ol>

  <h4>5. Sprzedaż sprzętu</h4>
  <ol class="list-decimal">
    <li>
      Operator Platformy, oprócz świadczenia Usług w ramach Platformy, może oferować Klientom sprzedaż sprzętu
      niezbędnego lub pomocniczego do korzystania z Usług.
    </li>
    <li>
      Informacje o oferowanym sprzęcie, jego specyfikacji technicznej, cenie oraz warunkach dostawy prezentowane są w
      ofercie Operatora Platformy lub przekazywane Klientowi indywidualnie w toku Negocjacji.
    </li>
    <li>Z chwilą dokonania pełnej zapłaty ceny za sprzęt, własność sprzętu przechodzi na Klienta.</li>
    <li>
      Operator Platformy zobowiązuje się dostarczyć sprzęt wolny od wad fizycznych i prawnych, zgodnie z obowiązującymi
      przepisami prawa.
    </li>
    <li>
      W przypadku ujawnienia się wady sprzętu, Klientowi przysługują uprawnienia wynikające z przepisów Kodeksu
      cywilnego dotyczących rękojmi, chyba że strony uzgodniły odrębnie inne warunki gwarancji lub odpowiedzialności.
    </li>
    <li>
      Dostawa sprzętu odbywa się na adres wskazany przez Klienta, za pośrednictwem operatora logistycznego
      współpracującego z Operatorem Platformy, o ile strony nie ustalą inaczej.
    </li>
    <li>Koszty dostawy sprzętu ponosi Klient, chyba że oferta sprzedaży stanowi inaczej.</li>
    <li>
      Operator Platformy może uzależnić dostarczenie sprzętu od uprzedniego uregulowania wszelkich należności wobec
      Operatora Platformy.
    </li>
  </ol>

  <h4>6. Czas trwania Umowy Konta Klienta i Rozwiązanie Umowy Konta Klienta</h4>
  <ol class="list-decimal">
    <li>Umowa Konta Klienta zostaje zawarta na czas nieokreślony.</li>
    <li>
      Klient jest uprawniony do rozwiązania Umowy Konta w każdym czasie. Rozwiązanie Umowy Konta Klienta staje się
      skuteczne z końcem bieżącego Okresu Rozliczeniowego. Klient informuje Operatora Platformy o rozwiązaniu Konta za
      pośrednictwem poczty elektronicznej lub gdy Operator umożliwia taką opcję za pośrednictwem odpowiedniego
      rozwiązania w Koncie Klienta.
    </li>
    <li>
      Operator Platformy jest uprawniony do rozwiązania z Klientem Umowy Konta w każdym czasie. O rozwiązaniu Umowy
      Konta Operator Platformy poinformuje Klienta za pośrednictwem poczty elektronicznej na adres przypisany do Konta.
      Rozwiązanie Umowy Konta przez Operatora Platformy staje się skuteczne z końcem bieżącego Okresu Rozliczeniowego.
    </li>
    <li>
      Z chwilą rozwiązania Umowy Konta, Klient traci dostęp do informacji i funkcjonalności związanych z dostępem do
      Konta.
    </li>
  </ol>

  <h4>7. Wymagania techniczne.</h4>
  <ol class="list-decimal">
    <li>Korzystanie z Platformy odbywa się za pośrednictwem publicznej Sieci Internet.</li>
    <li>
      Minimalne wymagania techniczne umożliwiające korzystanie z Platformy i administrowanie Konta Klienta:
      <ol class="list-disc ml-2">
        <li>
          urządzenie z aktualnym systemem operacyjnym posiadające dostęp do sieci Internet lub sieci prywatnej, o której
          mowa w pkt 6.1.
        </li>
        <li>
          zainstalowana oraz prawidłowo skonfigurowana i aktualna wersja przeglądarki internetowej lub inne narzędzie
          Klienta HTTP.
        </li>
        <li>aktywne konto poczty elektronicznej.</li>
        <li>
          w przypadku korzystania z aplikacji uruchamianej na urządzeniach (np. tabletach) - urządzenie musi spełniać
          minimalne parametry techniczne określone przez Operatora Platformy; Operator może oferować dedykowane tablety
          w pełni kompatybilne z aplikacją, a w przypadku korzystania z urządzeń własnych Klienta Operator nie ponosi
          odpowiedzialności za nieprawidłowe działanie aplikacji wynikające z niespełnienia wymagań technicznych.
        </li>
      </ol>
    </li>
  </ol>

  <h4>8. Własność intelektualna</h4>
  <ol class="list-decimal">
    <li>
      Platforma jako wyłączna własność Operatora Platformy objęta jest ochroną praw autorskich. Chroni ona zawartość
      Platformy, narzędzia składające się na jego funkcjonalności oraz inne utwory kwalifikowane przez prawo autorskie
      jako dzieła chronione. Wszelkie prawa należą do Operatora Platformy lub Operator Platformy posiada prawo do
      korzystania z nich na podstawie odrębnej umowy.
    </li>
    <li>
      Zabronione jest jakiekolwiek przetwarzanie danych i innych informacji dostępnych w Platformie w celu udostępnienia
      ich osobom trzecim w ramach innych serwisów internetowych, jak również poza siecią Internet.
    </li>
    <li>
      Operator Platformy zastrzega, że jakiekolwiek wykorzystywanie, modyfikowanie lub dalsze publikowanie
      zmodyfikowanego utworu będącego własnością Operatora Platformy jest zabronione.
    </li>
  </ol>

  <h4>9. Ochrona danych osobowych</h4>
  <ol class="list-decimal">
    <li>
      Operator działa zgodnie z obowiązującymi przepisami o ochronie danych osobowych. Szczegółowe informacje, zakres,
      zasady i warunki prywatności dostępne są na stronie:
      <a href="https://soft4lean.app/privacy-policy">https://soft4lean.app/privacy-policy</a>
    </li>
  </ol>

  <h4>10. Powierzenie przetwarzania danych osobowych</h4>
  <ol class="list-decimal">
    <li>
      W związku ze świadczeniem Usług na rzecz Klienta, Operator Platformy może przetwarzać dane osobowe, których
      administratorem jest Klient.
    </li>
    <li>
      W zakresie, w jakim Operator Platformy przetwarza dane osobowe w imieniu Klienta, strony zawierają umowę
      powierzenia przetwarzania danych osobowych, której treść stanowi Załącznik nr 1 do niniejszego Regulaminu.
    </li>
    <li>
      Akceptacja niniejszego Regulaminu przez Klienta jest równoznaczna z zawarciem umowy powierzenia przetwarzania
      danych osobowych.
    </li>
  </ol>

  <h4>11. Niedopuszczalne działania Klienta</h4>
  <ol class="list-decimal">
    <li>
      Klient jest uprawniony do korzystania z Platformy zgodnie z jej przeznaczeniem, w granicach prawa i przyzwoitości
      publicznej oraz z poszanowaniem praw i własności innych osób. W szczególności Klient zobowiązuje się:
      <ol class="list-disc ml-2">
        <li>
          nie podejmować działań, które mogłyby zakłócić prawidłowe funkcjonowanie Platformy, w tym nie ingerować w
          zawartość Platformy oraz Kont ani w elementy informatyczne Platformy;
        </li>
        <li>nie podejmować działań nieetycznych lub niezgodnych z prawem;</li>
        <li>
          powstrzymać się od: działania w złej wierze, nadużywania funkcjonalności Platformy, wykorzystywania Platformy
          i usług świadczonych za jej pośrednictwem niezgodnie z jej przeznaczeniem i niezgodnie z Regulaminem;
        </li>
      </ol>
    </li>
    <li>
      Klient zobowiązany jest do przestrzegania obowiązków określonych w punkcie 10 Regulaminu na każdym etapie
      korzystania z Platformy, w odniesieniu do każdej oferowanej funkcjonalności.
    </li>
    <li>
      Operator Platformy jest uprawniony do zablokowania Konta, jeżeli zachodzi podejrzenie, że za pośrednictwem Konta
      mogły lub mogą być podejmowane działania zagrażające bezpieczeństwu Klientów w Platformie, jak również w
      przypadku, gdy działania podejmowane za pośrednictwem Konta negatywnie wpływają na dobre imię Operatora Platformy
      lub w inny sposób szkodzą Operatorowi Platformy.
    </li>
    <li>
      W przypadku poważnego naruszenia prawa z wykorzystaniem Platformy, jak również poważnego lub powtarzającego się
      naruszenia Regulaminu, Operator Platformy może, z zachowaniem zasad proporcjonalności i poszanowania swobody
      obrotu, zawiesić Konto lub czasowo lub trwale je zablokować, co będzie równoznaczne z czasowym zawieszeniem
      świadczenia usług na rzecz Klienta, z zastrzeżeniem poniższych zasad:
      <ol>
        <li>
          zawieszenie Konta oznacza czasowe zawieszenie jego funkcjonalności. Klient, którego Konto zostało zawieszone,
          traci możliwość aktywnego korzystania z Platformy.
        </li>
        <li>zablokowanie Konta oznacza, że Klient traci możliwość logowania się na Konto.</li>
      </ol>
    </li>
  </ol>

  <h4>12. Odpowiedzialność Operatora Platformy</h4>
  <ol class="list-decimal">
    <li>
      Operator Platformy podejmuje uzasadnione starania, aby zapewnić aktualność, dokładność i nieprzerwaną dostępność
      zawartości i funkcjonalności Platformy. W tym celu w ramach Usługi Operator Platformy usuwa wszelkie błędy
      występujące w Platformie bez zbędnej zwłoki.
    </li>
    <li>
      Operator Platformy nie ponosi odpowiedzialności za poprawność działania operatorów zapewniających łączność z
      Platformą zarówno po stronie Operatora Platformy, jak i osób korzystających z Platformy.
    </li>
  </ol>

  <h4>13. Zapytania i reklamacje.</h4>
  <ol class="list-decimal">
    <li>
      Zapytania, wnioski, reklamacje oraz uwagi Klienta dotyczące funkcjonowania Platformy, lub usług świadczonych za
      jej pośrednictwem należy kierować na dedykowany adres e-mail Operatora Platformy: contact&commat;intechnity.com.
      Reklamacja powinna zawierać co najmniej adres e-mail przypisany do Konta Klienta oraz dokładny opis okoliczności i
      nieprawidłowości będących przyczyną reklamacji. Jeżeli podane w reklamacji dane lub informacje nie pozwolą
      Operatorowi Platformy na rozpoznanie reklamacji, Operator Platformy zwróci się do Klienta o wyjaśnienie
      wątpliwości lub o udzielenie dodatkowych informacji drogą elektroniczną, jeżeli będzie to konieczne do rozpoznania
      reklamacji przez Operatora Platformy, wskazując dokładnie takie wątpliwości lub wymagane informacje. Jeżeli pomimo
      tego Klient nie prześle wymaganych danych, Operator Platformy może pozostawić reklamację bez rozpatrzenia.
    </li>
    <li>
      Reklamacja powinna być złożona w terminie 30 dni od zaistnienia reklamowanego zdarzenia. Reklamacje nie będą
      rozpatrywane po upływie wspomnianego 30-dniowego terminu.
    </li>
    <li>
      Reklamacje będą rozpatrywane w terminie 14 dni w stosunku do osób uznanych za konsumentów w rozumieniu art. 221
      kodeksu cywilnego, w od daty ich otrzymania oraz w terminie 30 dni w stosunku do pozostałych podmiotów. Odpowiedź
      na reklamację wysyłana jest drogą elektroniczną na adres podany w zgłoszeniu reklamacyjnym.
    </li>
    <li>
      Składając reklamację Klient zgadza się na przetwarzanie danych osobowych w zakresie adresu e-mail, z którego
      została wysłana reklamacja.
    </li>
  </ol>

  <h4>14. Postanowienia końcowe</h4>
  <ol class="list-decimal">
    <li>
      Operator Platformy ma prawo do zmiany postanowień Regulaminu poprzez ich zamieszczenie w Platformie i dostarczenie
      takiej informacji do Klienta na podany adres e-mail. Zmiany wchodzą w życie w terminie wskazanym przez Operatora
      Platformy, chyba że obowiązujące przepisy prawa stanowią inaczej. Klient powinien zapoznać się ze zmianami
      wprowadzonymi przez Operatora Platformy.
    </li>
    <li>
      Klient, który nie wyraża zgody na zmiany w Regulaminie, nie może korzystać z Konta po upływie terminu, o którym
      mowa w pkt 12.1. Dalsze korzystanie przez Klienta z Platformy po wejściu w życie zmian w Regulaminie jest
      równoznaczne z akceptacją tych zmian.
    </li>
    <li>
      Osoba fizyczna zawierająca z Operatorem Platformy umowę treści cyfrowych bezpośrednio związaną z jej działalnością
      gospodarczą, gdy z treści tej umowy wynika, że nie posiada ona dla tej osoby charakteru zawodowego, może w
      terminie 14 dni od zawarcia umowy odstąpić od niej bez podania przyczyny. Odstąpienie w tym trybie nie jest
      możliwe, jeżeli przed upływem tego terminu:
      <ol class="list-disc ml-2">
        <li>Operator Platformy w pełni wykonał daną odpłatną usługę; albo</li>
        <li>
          w przypadku usług odpłatnych, których przedmiotem jest dostarczenie usług cyfrowych Klient jest zobowiązany do
          zapłaty ceny, Operator Platformy rozpocznie świadczenie takich usług; oraz Klient wyraził uprzednio wolę
          skorzystania z usługi, będąc świadomym, że po spełnieniu świadczenia przez Operatora Platformy utraci prawo
          odstąpienia od umowy.
        </li>
      </ol>
    </li>
    <li>
      Prawem właściwym dla wszelkich umów pomiędzy Klientem a Operatorem Platformy są odpowiednie przepisy prawa
      polskiego.
    </li>
    <li>
      Jeżeli jakiekolwiek postanowienie niniejszego Regulaminu jest nieważne lub nieskuteczne, nie wpływa to na ważność
      pozostałych postanowień. Nieważne lub nieskuteczne postanowienia zostaną zastąpione postanowieniami, które w
      największym stopniu odpowiadają celowi biznesowemu i charakterowi relacji między Operatorem Platformy a Klientem.
    </li>
  </ol>
</div>

<div class="text-base p-8 mt-16">
  <h1>Załącznik nr 1 do Regulaminu Platformy Soft4Lean SWI</h1>
  <h2>Umowa powierzenia przetwarzania danych osobowych</h2>

  <p>
    Niniejsza umowa powierzenia („Umowa”) stanowi integralną część Regulaminu Platformy Soft4Lean SWI („Regulamin”).
  </p>

  <p>Umowa zostaje zawarta pomiędzy:</p>
  <ul>
    <li>
      <strong>Intechnity Sp. z o.o.</strong>, ul. Technologiczna 2, 45-839 Opole, NIP: 7543368340, REGON: 0001101111 -
      dalej „Operator” albo „Podmiot przetwarzający”,
    </li>
    <li><strong>Klientem</strong> akceptującym Regulamin - dalej „Administrator”.</li>
  </ul>

  <p>Akceptacja Regulaminu przez Klienta jest równoznaczna z zawarciem niniejszej Umowy w formie elektronicznej.</p>

  <h4>1. Podstawa prawna i definicje</h4>
  <ol class="list-decimal">
    <li>
      Umowa jest zawarta na podstawie art. 28 Rozporządzenia (UE) 2016/679 z dnia 27 kwietnia 2016 r. (RODO) oraz
      przepisów krajowych (w szczególności ustawy z 10.05.2018 r. o ochronie danych osobowych).
    </li>
    <li>Pojęcia niezdefiniowane inaczej mają znaczenie nadane w RODO i Regulaminie.</li>
  </ol>

  <h4>2. Przedmiot, charakter, cel i czas przetwarzania</h4>
  <ol class="list-decimal">
    <li>
      Administrator powierza Operatorowi przetwarzanie danych osobowych wyłącznie w celu świadczenia usług SaaS w ramach
      Platformy <strong>Soft4Lean SWI</strong> zgodnie z Regulaminem („Usługi”).
    </li>
    <li>
      Charakter operacji: zbieranie, uporządkowywanie, przechowywanie, modyfikowanie, ograniczanie, udostępnianie na
      polecenie Administratora, usuwanie - w zakresie niezbędnym do świadczenia Usług.
    </li>
    <li>
      Czas trwania: przez okres obowiązywania umowy o świadczenie Usług wynikającej z akceptacji Regulaminu, a następnie
      do czasu wykonania czynności końcowych, o których mowa w punkcie 10.
    </li>
  </ol>

  <h4>3. Kategorie osób i zakres danych</h4>
  <ol class="list-decimal">
    <li>
      Kategorie osób: użytkownicy systemu (np. pracownicy/współpracownicy Administratora), kontrahenci, klienci lub inni
      interesariusze wprowadzeni do systemu przez Administratora.
    </li>
    <li>
      Zakres typowy: imię, nazwisko, adres e-mail, numer telefonu, identyfikatory kont, dane organizacyjne (firma,
      stanowisko, dział), metadane techniczne (logi, identyfikatory urządzeń, adresy IP), inne dane wprowadzone przez
      Administratora w związku z korzystaniem z funkcjonalności Platformy.
    </li>
    <li>
      Administrator nie powinien przetwarzać w Platformie szczególnych kategorii danych (art. 9 RODO) ani danych o
      wyrokach skazujących (art. 10 RODO), chyba że funkcjonalność, podstawa prawna i instrukcje Administratora
      przewidują to wprost.
    </li>
  </ol>

  <h4>4. Instrukcje i zgodność z prawem</h4>
  <ol class="list-decimal">
    <li>
      Operator przetwarza dane wyłącznie na udokumentowane polecenie Administratora (w tym przez konfiguracje/ustawienia
      w koncie, API, ticket, e-mail z adresu przypisanego do konta).
    </li>
    <li>
      Administrator oświadcza, że posiada podstawy prawne przetwarzania danych w zakresie, w jakim zleca ich
      przetwarzanie Operatorowi.
    </li>
  </ol>

  <h4>5. Poufność</h4>
  <ol class="list-decimal">
    <li>
      Operator zapewnia, że osoby dopuszczone do przetwarzania danych są zobowiązane do zachowania tajemnicy oraz
      zostały odpowiednio przeszkolone.
    </li>
    <li>Obowiązek poufności obowiązuje również po ustaniu Umowy.</li>
  </ol>

  <h4>6. Bezpieczeństwo przetwarzania</h4>
  <ol class="list-decimal">
    <li>
      Operator wdraża i utrzymuje odpowiednie środki techniczne i organizacyjne zgodnie z art. 32 RODO, uwzględniające
      m.in.: pseudonimizację/anonymizację (jeśli stosowana), szyfrowanie w tranzycie i - gdzie zasadne - w spoczynku,
      kontrolę dostępu, minimalizację uprawnień, rejestrowanie zdarzeń, testy i oceny skuteczności.
    </li>
    <li>
      Operator prowadzi rejestr kategorii czynności przetwarzania, o których mowa w art. 30 ust. 2 RODO (jeżeli
      wymagane).
    </li>
  </ol>

  <h4>7. Zgłoszenia naruszeń i wsparcie</h4>
  <ol class="list-decimal">
    <li>
      Operator bez zbędnej zwłoki, nie później niż w ciągu 24 godzin od stwierdzenia naruszenia ochrony danych
      osobowych, informuje Administratora o naruszeniu, przekazując dostępne informacje wymagane art. 33 ust. 3 RODO w
      miarę ich pozyskiwania.
    </li>
    <li>
      Operator, biorąc pod uwagę charakter przetwarzania, wspiera Administratora w realizacji obowiązków wynikających z
      art. 32-36 RODO oraz w obsłudze żądań osób, których dane dotyczą (art. 12-22 RODO) - w zakresie możliwym i
      uzasadnionym.
    </li>
  </ol>

  <h4>8. Podprzetwarzający (subprocesorzy)</h4>
  <ol class="list-decimal">
    <li>
      Administrator udziela ogólnego upoważnienia do korzystania przez Operatora z podprzetwarzających niezbędnych do
      świadczenia Usług (m.in. dostawcy chmury/hostingu, e-mail, analityki, utrzymanie infrastruktury, systemy
      płatności).
    </li>
    <li>
      Operator zapewnia, aby każdy podprzetwarzający przyjął co najmniej równoważne zobowiązania jak wynikające z
      niniejszej Umowy (art. 28 ust. 4 RODO).
    </li>
    <li>
      Aktualna lista podprzetwarzających jest publikowana w Polityce prywatności na stronie Platformy i może być
      okresowo aktualizowana. Dalsze korzystanie z Usług po publikacji zmian oznacza akceptację zmian. Administrator
      może zgłosić uzasadniony sprzeciw - w takim przypadku Strony podejmą działania w dobrej wierze celem wypracowania
      rozwiązania.
    </li>
  </ol>

  <h4>9. Audyty i informacje</h4>
  <ol class="list-decimal">
    <li>
      Operator udostępnia Administratorowi informacje niezbędne do wykazania spełnienia obowiązków z art. 28 RODO (np.
      opisy środków bezpieczeństwa, certyfikacje, raporty z testów - jeśli dostępne).
    </li>
    <li>
      Administrator może przeprowadzić uzgodniony z wyprzedzeniem audyt/inspekcję (z co najmniej 14-dniowym
      wyprzedzeniem, w godzinach pracy, bez zakłócania ciągłości Usług). W przypadku audytu na terenie lub w systemach
      poddostawców zastosowanie mogą mieć ich zasady dostępowe.
    </li>
  </ol>

  <h4>10. Zakończenie przetwarzania, zwrot i usunięcie danych</h4>
  <ol class="list-decimal">
    <li>
      Po zakończeniu świadczenia Usług Operator - według wyboru Administratora zgłoszonego przed zakończeniem Umowy -
      zwróci dane w uzgodnionym formacie lub usunie je ze swoich systemów (z wyjątkiem kopii wymaganych przez prawo lub
      kopii zapasowych, które zostaną nadpisane w standardowych cyklach retencji).
    </li>
    <li>Operator potwierdzi wykonanie czynności z ust. 1 stosowną informacją w systemie lub e-mailem.</li>
  </ol>

  <h4>11. Odpowiedzialność</h4>
  <ol class="list-decimal">
    <li>
      Każda ze Stron odpowiada za szkodę spowodowaną przetwarzaniem danych niezgodnym z RODO lub Umową w zakresie, w
      jakim ponosi za nią winę (art. 82 RODO).
    </li>
    <li>
      W relacji Operator-Administrator odpowiedzialność Operatora jest ograniczona do szkód bezpośrednich i - w relacji
      B2B - do wysokości łącznych opłat zapłaconych Operatorowi przez Administratora w ostatnich 12 miesiącach, z
      wyłączeniem szkód spowodowanych umyślnie.
    </li>
  </ol>

  <h4>12. Przekazywanie danych poza EOG</h4>
  <ol class="list-decimal">
    <li>
      Jeżeli w ramach Usług dojdzie do przekazania danych poza EOG, Operator zapewni odpowiednie mechanizmy zgodności
      (np. standardowe klauzule umowne UE lub decyzję stwierdzającą odpowiedni stopień ochrony) i poinformuje o tym w
      dokumentacji usługowej/Polityce prywatności.
    </li>
  </ol>

  <h4>13. Postanowienia końcowe</h4>
  <ol class="list-decimal">
    <li>Prawem właściwym jest prawo polskie, z uwzględnieniem bezwzględnie obowiązujących przepisów RODO.</li>
    <li>Wszelkie spory rozstrzyga sąd powszechny właściwy dla siedziby Operatora.</li>
    <li>Zmiany Umowy mogą następować w trybie zmian Regulaminu.</li>
    <li>
      Umowa obowiązuje od chwili akceptacji Regulaminu przez Klienta i pozostaje w mocy przez czas korzystania z Usług
      oraz do wykonania czynności końcowych z punktu 10.
    </li>
    <li>
      Umowa zawarta jest w formie elektronicznej; sporządzenie egzemplarzy papierowych ani podpisy własnoręczne nie są
      wymagane.
    </li>
  </ol>
</div>
